// src/components/payment/PayFirstFailed.tsx
import React from 'react';

export const PayFirstFailed: React.FC = () => {
  const supportPhone = '+965-56501847';

  const callSupport = () => {
    window.location.href = `tel:${supportPhone.replace(/-/g, '')}`;
  };

  const whatsappSupport = () => {
    const message = 'مرحباً، واجهت مشكلة في عملية الدفع وأحتاج مساعدة';
    const whatsappUrl = `https://wa.me/96556501847?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 py-8 px-4" dir="rtl">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Error Header */}
          <div className="bg-gradient-to-r from-red-500 to-orange-600 text-white p-8 text-center">
            <div className="w-24 h-24 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-3xl font-bold mb-2">فشل الدفع</h1>
            <p className="text-red-100 text-lg">لم تتم عملية الدفع</p>
          </div>

          <div className="p-6">
            {/* Error Message */}
            <div className="bg-red-50 rounded-xl p-6 mb-6 text-center">
              <p className="text-red-700 mb-3 font-medium text-lg">عذراً!</p>
              <p className="text-red-600">
                تم إلغاء عملية الدفع أو حدث خطأ أثناء المعالجة.
              </p>
              <p className="text-red-600 mt-2">
                لم يتم إنشاء المهمة ولم يتم خصم أي مبلغ.
              </p>
            </div>

            {/* What to do */}
            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <p className="text-gray-700 mb-3 font-medium text-center">
                ماذا يمكنك فعله؟
              </p>
              <ul className="text-gray-600 space-y-2 text-sm">
                <li className="flex items-start">
                  <span className="text-blue-500 ml-2">•</span>
                  حاول مرة أخرى باستخدام رابط الدفع الأصلي
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 ml-2">•</span>
                  تأكد من وجود رصيد كافٍ في بطاقتك
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 ml-2">•</span>
                  تواصل مع الدعم إذا استمرت المشكلة
                </li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              <button
                onClick={whatsappSupport}
                className="w-full bg-green-500 text-white py-4 px-6 rounded-xl font-bold text-lg hover:bg-green-600 transition-colors flex items-center justify-center"
              >
                <svg className="w-6 h-6 ml-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                تواصل عبر واتساب
              </button>

              <button
                onClick={callSupport}
                className="w-full bg-blue-600 text-white py-4 px-6 rounded-xl font-bold text-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
              >
                <svg className="w-6 h-6 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                اتصل بالدعم
              </button>
            </div>

            {/* Support Info */}
            <div className="text-center mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                للمساعدة الفورية
                <br />
                <span className="font-medium text-blue-600">📞 {supportPhone}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
